import type {AnimationEvent, PointerEvent, ReactElement} from 'react';
import {useState} from 'react';
import {AiChatChristmasAsset} from '@AiChat/lib/ai-chat-season-library.types';
import {AiChatChristmasAssetImage} from '@AiChat/components/ai-chat-christmas-asset-image/ai-chat-christmas-asset-image';
import {TOUCH_POINTER_TYPE} from './ai-chat-christmas-snowman.types';
import styles from './ai-chat-christmas-snowman.module.scss';

export function AiChatChristmasSnowman(): ReactElement {
  const [isWaving, setIsWaving] = useState<boolean>(false);

  const getSnowmanClassName = (): string => {
    if (isWaving) {
      return `${styles.snowman} ${styles.isWaving}`;
    }

    return styles.snowman;
  };

  const onSnowmanPointerEnter = (event: PointerEvent<HTMLSpanElement>): void => {
    if (event.pointerType === TOUCH_POINTER_TYPE) {
      return;
    }

    setIsWaving(true);
  };

  const onArmAnimationEnd = (event: AnimationEvent<HTMLSpanElement>): void => {
    if (event.target !== event.currentTarget) {
      return;
    }

    setIsWaving(false);
  };

  return (
    <span className={getSnowmanClassName()} onPointerEnter={onSnowmanPointerEnter}>
      <AiChatChristmasAssetImage asset={AiChatChristmasAsset.SNOWMAN} className={styles.body} />
      <span className={styles.arm} onAnimationEnd={onArmAnimationEnd}>
        <AiChatChristmasAssetImage asset={AiChatChristmasAsset.SNOWMAN_ARM} className={styles.armArt} />
      </span>
    </span>
  );
}
